import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { AuthForm } from "@/components/AuthForm";
import { useAuth } from "@/context/AuthContext";
import { loginLanding } from "@/lib/owner";

export default function Login() {
  const { user, loading } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (!loading && user) navigate(loginLanding(user), { replace: true });
  }, [user, loading, navigate]);

  // Iter126A: while the silent restore from the persistent owner cookie is still deciding, never flash the sign-in form
  if (loading || user) {
    return <div className="min-h-screen flex items-center justify-center bg-background" data-testid="login-restoring"><Loader2 className="w-6 h-6 animate-spin text-primary" /></div>;
  }

  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-background px-5 py-16">
      <button onClick={() => navigate("/")} className="mb-8 flex items-center gap-3">
        <img src="/logo-icon.png" alt="" className="h-10 w-auto" />
        <span className="font-heading text-3xl font-semibold tracking-tight text-primary">BareFootage</span>
      </button>
      <div className="w-full max-w-[420px] rounded-2xl border border-border bg-popover/60 backdrop-blur-xl p-7 shadow-2xl shadow-black/40">
        <AuthForm initialMode="login" onSuccess={(u) => navigate(loginLanding(u), { replace: true })} />
      </div>
    </div>
  );
}
